module.exports = __webpack_public_path__ + "static/img/two.57aa70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/two.png
// module id = z4yD
// module chunks = 1